import React from 'react'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import {Button, Col, Row} from 'react-bootstrap'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import {numberFormat} from '../../../utils/Functions'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {IncomeDocumentTypes} from '../../../constants/Common'
import {chequeRequiredKeys} from './TabDocumentPayment'
import usePayment from '../../../hook/usePayment'
import { formatDate } from '@fullcalendar/core'

interface ITabDocumentBilling {
  document: IIncomeDocument
  // billingDocuments: IIncomeDocument[]
}

const TabDocumentBilling: React.FC<ITabDocumentBilling> = (props) => {
  const {document} = props
  const location = useLocation()
  const navigate = useNavigate()
  const {_renderDetailPayCheque, _renderDetailPayBankAccount} = usePayment()
  const isInExpensePage = location.pathname.includes('expense')
  const isExpense = document.type.includes('expense')
  const isExpenseDepositPayment = IncomeDocumentTypes.EXPENSE_DEPOSIT_PAYMENT === document.type
  const isExpensePurchaseInventoryRecord =
    IncomeDocumentTypes.EXPENSE_PURCHASE_INVENTORY_RECORD === document.type

  const notShowReceipt = [
    IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE,
    IncomeDocumentTypes.EXPENSE_PURCHASE_DEBIT_NOTE,
    IncomeDocumentTypes.EXPENSE_COMBINED_PAYMENT_NOTE,
    IncomeDocumentTypes.EXPENSE_EXPENSE_RECORD,
    IncomeDocumentTypes.EXPENSE_PURCHASE_INVENTORY_RECORD,
    IncomeDocumentTypes.EXPENSE_DEPOSIT_PAYMENT,
  ].includes(document.type)

  if (!document) return <></>

  const fullPaymentAmount = document.totalAmount
  const billingHistories = document.billingHistories
  const billingNoteTotalAmount = billingHistories?.reduce((a, b) => a + b.billingAmount, 0)
  const billingHistoriesAlreadyPaid = billingHistories?.filter(
    (item) => item.incomeDocument.state === 'paid'
  )
  const billingNoteTotalReceivePayment = billingHistoriesAlreadyPaid?.reduce(
    (a, b) => a + b.billingAmount,
    0
  )

  return (
    <div>
      <KTCard>
        <KTCardBody className={'py-3 px-4'}>
          <Row className={'fs-6'}>
            <Col xs={12}>
              <h4>{isExpense ? 'ข้อมูลใบรับวางบิล' : 'ข้อมูลใบวางบิล'}</h4>
            </Col>
            <Col xs={6} className={'border-end'}>
              <div className={'d-flex justify-content-between'}>
                <strong>{`${
                  isExpense ? `มูลค่าที่นำไปจ่ายในใบรับวางบิล` : `มูลค่าที่นำไปวางบิลในใบวางบิล`
                } ${billingHistories?.length || 0} รายการ :`}</strong>
                <span>{`${numberFormat(billingNoteTotalAmount)} บาท`}</span>
              </div>
              <div className={'d-flex justify-content-between'}>
                <strong>{`${
                  isExpense
                    ? `มูลค่าใบรับวางบิลรับชำระเงินแล้ว`
                    : `มูลค่าใบวางบิลที่รับชำระเงินแล้ว`
                } ${billingHistoriesAlreadyPaid?.length || 0} รายการ :`}</strong>
                <span style={{color: '#43bf76'}}>{`${numberFormat(
                  billingNoteTotalReceivePayment
                )} บาท`}</span>
              </div>
            </Col>
            <Col xs={6}>
              <div className={'d-flex justify-content-between'}>
                <strong>{`${
                  isExpense
                    ? `มูลค่าที่ใบรับวางบิลที่รอรับชำระเงิน`
                    : `มูลค่าที่ใบวางบิลที่รอรับชำระเงิน`
                } :`}</strong>
                <span>{`${numberFormat(
                  billingNoteTotalAmount - billingNoteTotalReceivePayment
                )} บาท`}</span>
              </div>
            </Col>
          </Row>
          <hr />
        </KTCardBody>
      </KTCard>
      {billingHistories.map((doc, docIndex) => {
        const incomeDocument = doc.incomeDocument
        // console.log('incomeDocument =>', {incomeDocument})

        return (
          <KTCard className={'mt-3'} key={`billing-note-${docIndex}`}>
            <KTCardBody className={'py-3 px-4'}>
              <Row className='fs-4 align-items-center'>
                <Col xs={12} md={6}>
                  <strong>{isExpense ? `ใบรับวางบิลเลขที่ :` : `ใบวางบิลเลขที่ :`}</strong>
                  <Link
                    to={`/${isExpense ? `expense-combined-payment-note` : `revenue-billing-note`}/${
                      incomeDocument.id
                    }/detail`}
                    target='_blank'
                    className='fw-bold ms-1'
                  >
                    #{incomeDocument.code}
                  </Link>
                </Col>
                <Col xs={12} md={6} className='text-md-end mt-2 mt-md-0'>
                  <strong>รวมจ่ายเมื่อวันที่ :</strong> {formatDate(doc.createdAt)}
                </Col>
              </Row>

              <Row className='fs-6'>
                <Col xs={12}>
                  <strong>มูลค่าที่นำมารวมจ่าย :</strong> {numberFormat(doc?.billingAmount || 0)} บาท
                </Col>
              </Row>
              <hr />
              {incomeDocument.incomeDocumentPayments.map((item: any, index: any) => {
                const receiptDocument = item?.receipt
                const alreadyHasReceipt =
                  document.type === IncomeDocumentTypes.RECEIPT || receiptDocument
                const isCheque = chequeRequiredKeys.some((key) => key in item && item[key] !== null)

                const whTaxPrice = item.whTaxPrice

                return (
                  <Row>
                    <Col xs={12}>
                      <h4 style={{color: '#43bf76'}}>{`รับชำระเงินครั้งที่ ${index + 1}`}</h4>
                    </Col>
                    <Col md={6} className={'border-end'}>
                      <strong className={'fs-5'}>{'ช่องทางการชำระ'}</strong>
                      {isCheque ? _renderDetailPayCheque(item) : _renderDetailPayBankAccount(item)}
                      <div className={'d-flex justify-content-between'}>
                        <strong>{'จำนวนเงิน :'}</strong>
                        {`${numberFormat(item.amount)} บาท`}
                      </div>
                      <div className={'d-flex justify-content-between'}>
                        <strong>{'ภาษีหัก ณ ที่จ่าย :'}</strong>
                        {`${numberFormat(whTaxPrice)} บาท`}
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className={'d-flex justify-content-between'}>
                        <strong>{'มูลค่าที่รับชำระเงินรวม :'}</strong>
                        <div
                          className={'py-2 px-3 text-end'}
                          style={{
                            minWidth: 150,
                            background: '#f5fcf8',
                            color: '#43bf76',
                          }}
                        >
                          <strong className={'fs-4'}>
                            {numberFormat(item.amount + whTaxPrice)}
                          </strong>
                          <span className={'ms-2'}>{'บาท'}</span>
                        </div>
                      </div>
                      {!notShowReceipt &&
                        (!isExpense ||
                          isExpenseDepositPayment ||
                          isExpensePurchaseInventoryRecord) && (
                          <div className={'d-flex justify-content-between align-items-center mt-3'}>
                            <strong
                              className={'fs-2'}
                              style={{color: alreadyHasReceipt ? '#43bf76' : '#f47459'}}
                            >
                              {alreadyHasReceipt
                                ? isInExpensePage
                                  ? 'รับใบเสร็จแล้ว'
                                  : 'ออกใบเสร็จแล้ว'
                                : isInExpensePage
                                ? 'รอรับใบเสร็จ'
                                : 'รอออกใบเสร็จ'}
                            </strong>
                            {!alreadyHasReceipt ? (
                              <Button
                                variant={'info'}
                                onClick={() => {
                                  navigate(
                                    `/revenue-receipt/create?docId=${incomeDocument.id}&paymentId=${
                                      item.id
                                    }&type=${document?.type || ''}`
                                  )
                                }}
                              >
                                {isInExpensePage ? 'รับใบเสร็จ' : 'ออกใบเสร็จ'}
                              </Button>
                            ) : (
                              <span>
                                {'เลขที่ใบเสร็จ :'}
                                <Link
                                  to={`/revenue-receipt/${
                                    receiptDocument ? receiptDocument.id : document.id
                                  }/detail`}
                                  target={'_blank'}
                                  className={'ms-1 fw-bold'}
                                >
                                  {receiptDocument ? receiptDocument.code : document.code}
                                </Link>
                              </span>
                            )}
                          </div>
                        )}
                    </Col>
                  </Row>
                )
              })}
            </KTCardBody>
          </KTCard>
        )
      })}
    </div>
  )
}

export default TabDocumentBilling
